// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"870":"9ce8a6bb","941":"b101beb4"}[chunkId] + ".chunk.js";
};